import { render, staticRenderFns } from "./salesHistory.vue?vue&type=template&id=463d6eae&scoped=true&"
import script from "./salesHistory.vue?vue&type=script&lang=js&"
export * from "./salesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463d6eae",
  null
  
)

export default component.exports